if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('ajax-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /* =========================================================
         MODIFIED SUBMIT HANDLER (MINIMAL CHANGE)
         ========================================================= */
     onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  const cartEl =
    document.querySelector('cart-drawer') ||
    document.querySelector('ajax-cart') ||
    document.querySelector('cart-notification');

  if (!cartEl) return;

  const country = (cartEl.dataset.customerCountry || '').toUpperCase();
  const variantId = this.variantIdInput.value;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {

      /* =========================================================
         🌍 INTERNATIONAL — HARD STOP (1 ITEM TOTAL)
         ========================================================= */
      if (country !== 'US' && cart.items.length >= 1) {
        this.handleErrorMessage('Limit 1 item total for international orders');
        return; // ⛔ STOP — do NOT add
      }

      /* =========================================================
         🇺🇸 US — PER PRODUCT MAX (METAFIELD)
         ========================================================= */
      if (country === 'US') {
        const item = cart.items.find(
          (i) => String(i.variant_id) === String(variantId)
        );

        const currentQty = item ? item.quantity : 0;


        const maxQty =
        parseInt(this.dataset.maxQty, 10) ||
        null;

        // Only block if product HAS a max
        if (maxQty && currentQty >= maxQty) {
        this.handleErrorMessage(`Limit ${maxQty} per item`);
        return;
        }

      }

      // ✅ SAFE TO ADD
      this._submitOriginal();
    });
}


      /* =========================================================
         ORIGINAL DAWN SUBMIT LOGIC (UNTOUCHED)
         ========================================================= */
      _submitOriginal() {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            this.cart.setAttribute('data-items-count', this.getCartItemCount(response));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /* =========================================================
         HELPERS (UNCHANGED)
         ========================================================= */
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getCartItemCount(response) {
        if (response.sections && response.sections['cart-icon-bubble']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');
          const countElement = doc.querySelector('[aria-hidden="true"]');
          if (countElement && countElement.textContent) {
            const count = parseInt(countElement.textContent.trim(), 10);
            return isNaN(count) ? 0 : count;
          }
        }
        return response.item_count || 0;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
